import { IRoleTypeService } from "../../service/role/RoleTypeService";

export default class GetRoleTypesInteractor {
  private roleTypeService: IRoleTypeService;

  constructor(roleTypeService) {
    this.roleTypeService = roleTypeService;
  }

  async execute() {
    return this.roleTypeService.getRoleTypes();
  }
}
